import { Card, CardBody } from "@heroui/react";
import { useState } from "react";

export default function VideoSection() {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoId = "y9V88gC2460";

  const handlePlayClick = () => {
    setIsPlaying(true);
  };

  return (
    <section className="py-8 px-4 md:px-8 z-20">
      <Card isHoverable className="max-w-[640px] w-full mx-auto">
        <CardBody className="rounded-lg">
          <div className="relative w-full aspect-video">
            {!isPlaying ? (
              <>
                <img
                  src={"/assets/face_compress.webp"}
                  alt="SEO analysis demo thumbnail"
                  className="absolute top-0 left-0 w-full h-full object-cover rounded-lg"
                />
                <button
                  onClick={handlePlayClick}
                  className="absolute inset-0 flex items-center justify-center w-full h-full bg-black/30 hover:bg-black/40 transition-colors rounded-lg group plausible-event-name=play-video"
                  aria-label="Play video"
                >
                  <svg
                    className="w-16 h-16 text-white group-hover:scale-110 transition-transform"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </button>
              </>
            ) : (
              <iframe
                src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                title="SEO analysis demo"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="absolute top-0 left-0 w-full h-full rounded-lg"
              />
            )}
          </div>
        </CardBody>
      </Card>
    </section>
  );
}
